module.exports = __webpack_public_path__ + "img/course_0013.c381b4f.webp";